import React, {useCallback} from 'react';
import WhatsAppImage from '../../../../pages/branding/whatsAppScreen/WhatsAppImage';
import * as css from './WhatsAppTab.css';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../redux/store.type';
import {uploadFile} from '../../../../redux/user/userActions';
import {TWhatsAppProps} from '../../types';
import WhatsAppTemplateEditor from '../../../whatsAppTemplateEditor/WhatsAppTemplateEditor';
import {TemplateStructure} from '../../../whatsAppTemplateEditor/types/templateStructure';

const WhatsAppTab = ({
    image = {path: '', imageId: ''},
    whatsappTemplate,
    message = '',
    saveImage,
    saveText,
    variablesType,
    mailingSource,
}: TWhatsAppProps) => {
    const lang = useSelector((s: RootState) => s.user.lang);
    const uid = useSelector((s: RootState) => s.user.uid);
    
    const handleImageSave = async (newImage) => {
        if(newImage?.image){
            saveImage(await uploadFile(newImage.image, '', 'whatsappImage', uid));
        }
    };
    const handleChange = useCallback((structure: TemplateStructure) => {
        saveText(structure);
    }, [saveText]);

    return (
        <>
            <WhatsAppImage
                image={image}
                saveImage={handleImageSave}
            />
            <css.editorSection>
                <WhatsAppTemplateEditor
                    variablesType={variablesType}
                    modeKey={mailingSource}
                    templateStructure={whatsappTemplate}
                    dependencies={[lang, whatsappTemplate]}
                    freeMessage={message}
                    onFreeMessageChange={saveText}
                    events={{onChange: handleChange}}
                />
            </css.editorSection>
        </>
    );
};

export default WhatsAppTab;
